import { render, staticRenderFns } from "./SearchSchoolBanner.vue?vue&type=template&id=0129e9b7&scoped=true"
import script from "./SearchSchoolBanner.vue?vue&type=script&lang=js"
export * from "./SearchSchoolBanner.vue?vue&type=script&lang=js"
import style0 from "./SearchSchoolBanner.vue?vue&type=style&index=0&id=0129e9b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0129e9b7",
  null
  
)

export default component.exports